import Vue from 'vue'
import Vuex from 'vuex'
import router from "../router";
import {http} from "@/axios";
import axios from 'axios';
import Counter from "../helpers/Counter";
import * as Fingerprint2 from 'fingerprintjs2'

//MODULES
import user from './user'
import helpers from './helpers'
import translates from './translates'
import account from './account/index'
import resume from './resume/index'
import vacancies from './vacancies/vacancies'
import candidate from './candidate';
// import filter from './filter'
import interaction from './interaction/index'
import interaction1 from './interaction1'
import receivedResumes from './receivedResumes';
import candidatesResumes from './candidatesResumes/candidatesResumes';
import accountSubscription from './account-subscription/index';
// import vacancyEdit from './vacancyEdit/index'

Vue.use(Vuex)
const counter = new Counter()

let loadCountryListPromise = null

const salaryTypes = [{
  id: 1,
  name: 'Per hour',
  shortName: 'p.hour',
}, {
  id: 2,
  name: 'Per day',
  shortName: 'p.day'
}, {
  id: 3,
  name: 'Per week',
  shortName: 'p.week'
}, {
  id: 4,
  name: 'Per month',
  shortName: 'p.month'
}, {
  id: 5,
  name: 'Per season',
  shortName: 'p.season'
}]

function getInitState() {
  return {
    key: counter.value,
    locales: {},
    localesNames: [],
    currentLocale: null,
    defaultLocale: 'ua',
    localesToClose: ['lt', 'pl'],
    currencies: [],
    currentCurrency: null,
    salaryTypes,
    countriesList: [],
    socialLinks: [],
    tshirtSizesList: [],
    shoeSizesList: [],
    tShirtSizesLoaded: false,
    shoeSizesListLoaded: false,

    pendingCountries: false,
    aiToken: '',
    fingerprint: '',
    hints: [],
  }
}

const store = new Vuex.Store({
  modules: {
    user,
    helpers,
    translates,
    account,
    resume,
    vacancies,
    candidate,
    // filter,
    interaction,
    interaction1,
    receivedResumes,
    candidatesResumes,
    accountSubscription,
    // vacancyEdit
  },
  state: getInitState(),
  mutations: {
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return
      state[key] = value
    },
    //RESET
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setLocales(state, locales) {
      state.locales = locales
      state.localesNames = Object.keys(locales)
    },
    setCurrentLocale(state, locale) {
      state.currentLocale = locale
    },
    setCurrencies(state, currencies) {
      state.currencies = currencies
    },
    setCurrentCurrency(state, currency) {
      state.currentCurrency = currency
    },
    incrementKey(state) {
      state.key = counter.value
    },
    setCountriesList(state, countries) {
      state.countriesList = countries
    },
    setTShirtSizesList(state, sizes) {
      state.tShirtSizesLoaded = true
      state.tshirtSizesList = sizes
    },
    setShoeSizesList(state, sizes) {
      state.shoeSizesListLoaded = true
      state.shoeSizesList = sizes
    },
    saveSocialLinks(state, socials) {
      state.socialLinks = socials
    },
    setAiLogged(state, val) {
      state.aiToken = val
    },
    setFingerprint(state, val) {
      state.fingerprint = val
    }
  },
  actions: {
    async init({dispatch}) {
      return Promise.all([
        //USER
        dispatch('user/init'),

        //TRANSLATES
        await dispatch('translates/loadAll'),

        //COUNTRY LIST
        // dispatch('loadCountryList'),
      ])
    },

    // LOCALES
    loadLocales() {
      return http.get('/api/helper/available-languages').then(({data}) => {
        return data.data
      })
    },
    setLocales(undefined, locales) {
      setLocales(locales)
    },
    setCurrentLocale(undefined, currentLocale) {
      setCurrentLocale(currentLocale)
    },
    async changeCurrentLocale({dispatch}, locale) {
      dispatch('sendAlert', {
        type: 'select',
        title: `change locale to ${locale}`
      })

      dispatch('setCurrentLocale', locale);

      window.location.reload();
    },

    // CURRENCIES
    setCurrentCurrency(undefined, currentCurrency) {
      setCurrentCurrency(currentCurrency)
    },
    async changeCurrentCurrency({dispatch}, currentCurrency) {
      await dispatch('setCurrentCurrency', currentCurrency)
      await dispatch('resetAll')

      dispatch('sendAlert', {
        type: 'select',
        title: `change currency to ${currentCurrency.currency}`
      })
    },

    async getHints(_, { group }) {
      const { data } = await http.get('/api/helper/hints', { params: { group } });
      return data?.data;
    },
    loadCountryList({state, commit}) {
      if (state.countriesList.length || state.pendingCountries) return loadCountryListPromise || Promise.resolve()
      commit('setProperty', ['pendingCountries', true])

      loadCountryListPromise = http.get('/api/helper/countries').then(({data}) => {
        commit('setCountriesList', data.data)
      }).finally(() => {
        commit('setProperty', ['pendingCountries', false])
        loadCountryListPromise = null
      })

      return loadCountryListPromise
    },

    loadTShirtSizes({state, commit}) {
      if (state.tShirtSizesLoaded) return Promise.resolve()

      return http.get('/api/helper/selectbox/resume_health_tshort')
          .then(({data}) => {
            commit('setTShirtSizesList', data.data)
          });
    },
    loadShoesSizes({state, commit}) {
      if (state.shoeSizesListLoaded) return Promise.resolve()


      return http.get('/api/helper/selectbox/resume_health_shoes')
          .then(({data}) => {
            commit('setShoeSizesList', data.data)
          });
    },
    // RESET ALL
    async resetAll({rootState, commit, dispatch}) {
      // commit('filter/resetState')
      commit('user/resetState')
      if (rootState.vacancyEdit) {
        commit('vacancyEdit/resetState')
      }
      await dispatch('init')
      commit('incrementKey')
    },

    // AI
    ailogin: async function ({commit, dispatch}) {
      if(process.env.NODE_ENV === 'development') return

      let data = {};
      data.email = 'a@whiteweb.ua';
      data.password = 'MasterFlomaster123';
      data.persistent = 'true';

      getFingerprint()
      trackMouseSpeed()

      axios.post('https://jobian-ai.whiteweb.com.ua/api/v1/auth/login', data)
        .then((data) => {
          commit('setAiLogged', data.data.token)
        })
        .catch(()=>{})
        .finally(()=>{dispatch('sendAlert', {type: 'init'})})
    },
    sendAlert: async function ({state}, params) {
      if(process.env.NODE_ENV === 'development') return

      let data = {},
        now = new Date(),
        device,
        ua = navigator.userAgent,
        metaTitle = document.head.querySelector('title').innerHTML;

      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {device = 'Tab'}
      else if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {device = 'Mob'}
      else {device = 'Pc'}

      function getCid() {
        let match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
        let raw = (match) ? decodeURIComponent(match[1]) : null;
        if (raw) {
          match = raw.match(/(\d+\.\d+)$/);
        }
        let gacid = (match) ? match[1] : null;
        if (gacid) {
          return gacid;
        }
      }
      //necessary params (or)
      if (state.user.profile !== null) {data.user_id = `${state.user.profile['id']}`}
      if (state.fingerprint) {data.fingerprint = state.fingerprint}
      //--------

      if(params) {
        if (params.title) {
          // data.title = metaTitle + '. ' + params.title
          data.title = params.title
        } else {
          data.title = metaTitle
        }

        if (params.method) {data.method = params.method}
        if (params.type) {data.type = params.type}
        if (params.params) {data.query_parameters = params.params.replace(/["']/g, '').replace(/[|]/g, ', ')}
        if (params.query) {data.query = params.query}
      }

      data.scheme = location.protocol;
      data.host = location.hostname;
      data.path = router.history.current.fullPath;
      data.language = navigator.language;
      data.resolution = window.screen.width + 'x' + window.screen.height;
      data.date_tracked = now.toISOString().replace('T', ' ').slice(0, 19);
      data.device = `${device}, ${ua}, ${getBrowserId()}`;
      data.tid = 'UA-161194013-1';
      data.cid = getCid();
      data.color_depth = `${window.screen.colorDepth}`;
      data.viewport = window.innerWidth + 'x' + window.innerHeight;
      data.source = 'front';

      if(data.user_id || data.fingerprint) {
       axios.post('https://jobian-ai.whiteweb.com.ua/api/v1/global_data', data, {headers: {Authorization: 'Bearer ' + state.aiToken}})
          .then((data) => {
            return data
          }).catch(() => {})
      }
    }
  }
})

//LOCALES

function getLocale(possibleLocales) {
  if (!possibleLocales) return null
  let locale;

  if (navigator.userAgent === 'prerender') {
    locale = location.pathname.split('/')[1]
    if (possibleLocales.hasOwnProperty(locale)) {
      return locale
    }

    return 'ua'
  }

  locale = getLocaleFromLocalStorage()
  if (possibleLocales.hasOwnProperty(locale)) {
    return locale
  }

  locale = getLocaleFromBrowser(possibleLocales)
  if (locale) {
    return locale
  }

  return 'en'
}

// function getLocaleObjectFromList(possibleLocales, locale) {
//   if (!locale) return null
//
//   for (let localeObj of possibleLocales) {
//     if (localeObj.props.regional === locale) {
//       return localeObj
//     }
//   }
//
//   return null
// }

function getLocaleFromBrowser(possibleLocales) {
  if (!window.navigator.language) return null

  let locale = window.navigator.language.split('-')
  if (locale[0]) locale[0] = locale[0].toLowerCase()
  if (locale[1]) locale[1] = locale[1].toLowerCase()

  for (let key in possibleLocales) {
    if (key === locale[0] || key === locale[1]) {
      return key
    }
  }
}

function setLocaleToLocalStorage(locale) {
  localStorage.setItem('locale', locale)
}

function getLocaleFromLocalStorage() {
  return localStorage.getItem('locale')
}

function setPossibleLocalesToLocalStorage(possibleLocales) {
  if (!possibleLocales) return
  localStorage.setItem('possibleLocales', JSON.stringify(possibleLocales))
}

// FINGERPRINT
function getFingerprint(){
  Fingerprint2.get((components) => {
    let fingerprint = Fingerprint2.x64hash128(components.map((pair) => {
      return pair.value
    }).join(), 31)
    store.commit('setFingerprint', fingerprint)
  })
}

// MOUSE SPEED
function trackMouseSpeed(){
  let timestamp = 0,
      speed = 0,
      mY = 0;

  document.addEventListener("mousemove", function(ev){
    let now = Date.now(),
        currentmY = ev.screenY;

    let dt = now - timestamp,
    distance = Math.abs(currentmY - mY);
    speed = Math.round(distance / dt * 1000);

    mY = currentmY;
    timestamp = now;
  }, false)

  setInterval(()=>{
    if(speed !== 0) {
      store.dispatch('sendAlert', {
        type: 'mouse',
        title: `${speed} px/s`
      })
    }
    speed = 0;
  }, 300000)
}


function getBrowserId () {
  let aKeys = ["MSIE", "Firefox", "Safari", "Chrome", "Opera"],
      sUsrAg = navigator.userAgent,
      nIdx = aKeys.length - 1;

  for (nIdx; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);

  return aKeys[nIdx]
}
// ---------------------------------------

// function getPossibleLocalesFromLocalStorage() {
//   let str = localStorage.getItem('possibleLocales')
//   if (!str) return null
//
//   try {
//     return JSON.parse(str)
//   } catch (e) {
//     return null;
//   }
// }

// CURRENCIES

function getCurrency(possibleCurrencies) {
  if (!possibleCurrencies) return null

  let currencyId = getCurrencyIdFromLocalStorage()
  let currency = possibleCurrencies.find(currency => currency.id === +currencyId)

  if (currency) {
    return currency
  }

  return possibleCurrencies[0]
}

function setCurrencyIdToLocalStorage(currencyId) {
  localStorage.setItem('currency', currencyId)
}

function getCurrencyIdFromLocalStorage() {
  return localStorage.getItem('currency')
}

function setLocales(locales) {
  setPossibleLocalesToLocalStorage(locales)
  store.commit('setLocales', locales)
}

function setCurrentLocale(currentLocale) {
  setLocaleToLocalStorage(currentLocale)
  document.documentElement.setAttribute('lang', store.state.locales[currentLocale].regional.replace('_', '-'))
  store.commit('setCurrentLocale', currentLocale)

  /*if (router && !router.currentRoute.params.lang && store.state.currentLocale !== 'ua') {
    let name = router.currentRoute.name
    if (name.endsWith('-double')) {
      name = name.replace('-double', '')
    }

    console.log(name)

    return router.push({
      name: name,
      params: {
        ...router.currentRoute.params,
        lang: store.state.currentLocale
      },
      query: {...router.currentRoute.query},
    })
  }*/
}

function setCurrentCurrency(currentCurrency) {
  setCurrencyIdToLocalStorage(currentCurrency.id)
  store.commit('setCurrentCurrency', currentCurrency)
}

// START INIT
function startInit() {
  // store.dispatch('ailogin')
  const configs = globalConfigs

  // LOCALES
  const locales = configs.languages;
  const currentLocale = getLocale(locales)

  setLocales(locales)
  setCurrentLocale(currentLocale)

  // CURRENCIES
  const currencies = configs.currencies;
  const currentCurrency = getCurrency(currencies);

  store.commit('setCurrencies', currencies)
  setCurrentCurrency(currentCurrency)
}

startInit()

export default store
